import React, { createContext, useEffect, useState } from "react";
import {
  listPlanApi,
  getAllRoles,
  assignbulkRoleApi,
  admiRoleListApi,
  commonRoleList,
} from "../../../api/Api";
import ViewIcon from "../../../assets/images/right-more.png";
import RouteConstants from "../../../constants/routeConstants.json";
import CheckBox from "../../../components/CheckBoxComponent/CheckBox";
import { useCookies } from "react-cookie";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

export const SubsrciptionPlanContext = createContext({});
export const SubsrciptionPlanContextProvider = ({ children }) => {
   const [searchParams] = useSearchParams();
   const pageFromUrl = searchParams.get("page");
  const [planList, setPlanList] = useState([]);
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [pageCount, setPageCount] = useState(pageFromUrl ? Number(pageFromUrl) : 1);
  const [totalPage, setTotalPage] = useState(0);
  const [rolesList, setRolesList] = useState([]);
  const [status, setStatus] = useState("");
  const [sorting, setSorting] = useState("");
  const [selectedSortId, setSelectedSortId] = useState(null);
  const [selectedStatusId, setSelectedStatusId] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showCountDropdown, setShowCountDropdown] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [roleSelectData, setRoleSelectData] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [role, setRole] = useState("");
  const [roleCategotyValidate, setRoleCategotyValidate] = useState("");
  const [successAlertShow, setSuccessAlertShow] = useState(false);
  const [successAlertMessage, setSuccessAlertMessage] = useState("");
  const [statusValue, setStatusValue] = useState(0);
  const [checkAllBox, setCheckAllBox] = useState(false);
  const [checkBoxDisable, setCheckBoxDisable] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState(false);
  const [buttonText, setButtonText] = useState("");

  const permissionAccess = JSON.parse(
    localStorage.getItem("permissions")
  )?.filter((item) => {
    return item.feature === "67371d68534964294f80cfe3";
  })[0];

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setCheckBoxDisable(selectedUsers.length === 0 ? false : true);
    setPlanList(
      apiData?.map((plan) => ({
        bulkData: (
          <div>
            <CheckBox
              key={plan._id}
              id={plan._id}
              check={selectedUsers.includes(plan._id)}
              onChange={(e) => {
                handleUserIdSelected(plan._id, e.target.checked);
              }}
            />
          </div>
        ),
        name: plan?.name,
        id: plan?._id,
        price: plan?.price ? `₹ ${plan.price}` : "-",
        billingCycle: plan?.billingCycle,
        status: (
          <span
            style={{
              color:
                plan?.status === "A"
                  ? "#13BC5B" // Green for Active
                  : plan?.status === "I"
                  ? "#EB5757" // Red for Inactive
                  : "#6c757d", // Default color (gray)
            }}
          >
            {plan?.status === "A"
              ? "ACTIVE"
              : plan?.status === "I"
              ? "INACTIVE"
              : "-"}
          </span>
        ),
        trialPeriod: plan?.trialPeriod,
        subCount: plan?.subscriberCount,
        action: (
          <div>
            <span
              onClick={() => {
                goToPlanDetails(plan?._id);
              }}
            >
              <img className="viewClickAdmin" src={ViewIcon} alt="view" />
            </span>
          </div>
        ),
      }))
    );
  }, [apiData, selectedUsers]);

  const goToPlanDetails = (id) => {
    navigate(RouteConstants.PLAN_DETAILS, { state: { id } });
  };

  const handleRoleChange = (e) => {
    setRole(e.target.value);
    roleValidation(e.target.value);
  };

  const roleValidation = (value) => {
    if (value === "") {
      setRoleCategotyValidate("Select role");
      return false;
    } else {
      setRoleCategotyValidate("");
      return true;
    }
  };

  // Function to handle individual selection
  const handleUserIdSelected = (userId, isChecked) => {
    setSelectedUsers(
      (prevSelectedUsers) =>
        isChecked
          ? [...prevSelectedUsers, userId] // Add the user ID if checked
          : prevSelectedUsers.filter((id) => id !== userId) // Remove the user ID if unchecked
    );
  };

  const roleListShown = async () => {
    try {
      const data = await admiRoleListApi();
      if (data?.data?.statusCode === 200) {
        setRoleList(data?.data?.data?.roleList);
      }
    } catch (error) {
      console.log(error);

      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || "Something went wrong...";

      setStatusValue(responseStatus);
      setErrorPopupMessage(errorMessage);
      setErrorPopup(true);

      if (responseStatus === 400) {
        setButtonText("Try Again");
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText("Login");
      } else {
        setButtonText("Try Again");
      }
    }
  };

  useEffect(() => {
    setSelectedUsers([]);
  }, [pageCount]);

  const onClickFilterButton = (statusId) => {
    setPageCount(1);
    setStatus(statusId);
    setShowDropdown(false);
  };
  const onClickSortButton = (sortId) => {
    setPageCount(1);
    setSorting(sortId);
    setShowCountDropdown(false);
  };

  const getPlanList = async (page, status, subscriberCount) => {
    try {
      setSpinnerStatus(true);
      const planListApiData = await listPlanApi(page, status, subscriberCount);
      if (planListApiData?.status === 200) {
        setSpinnerStatus(false);
        setApiData(planListApiData?.data?.data?.subscriptionPlans);
      }
      setTotalPage(planListApiData?.data?.data?.totalPages);
    } catch (error) {
      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || "Something went wrong...";

      setStatusValue(responseStatus);
      setErrorPopupMessage(errorMessage);
      setErrorPopup(true);

      if (responseStatus === 400) {
        setButtonText("Try Again");
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText("Login");
      } else {
        setButtonText("Try Again");
      }
    }
    setSpinnerStatus(false);
  };

  const bulkRoleAssignApi = async () => {
    const data = {
      users: selectedUsers,
      role: role,
    };
    const roleValidate = roleValidation(role);
    if (roleValidate) {
      try {
        setSpinnerStatus(true);
        const adminListApiData = await assignbulkRoleApi(data);
        if (adminListApiData?.data?.statusCode === 200) {
          setSuccessAlertShow(true);
          setSpinnerStatus(false);
          setSuccessAlertMessage(adminListApiData?.data?.message);
          setRoleSelectData(false);
        }
      } catch (error) {
        const responseStatus = error?.response?.data?.statusCode;
        const errorMessage =
          error?.response?.data?.message || "Something went wrong...";

        setStatusValue(responseStatus);
        setErrorPopupMessage(errorMessage);
        setErrorPopup(true);

        if (responseStatus === 400) {
          setButtonText("Try Again");
        } else if (responseStatus === 401 || responseStatus === 403) {
          setButtonText("Login");
        } else {
          setButtonText("Try Again");
        }
      }
    }
  };
  useEffect(() => {
    if (pageFromUrl) {
      setPageCount(Number(pageFromUrl));
    }
  }, [pageFromUrl]);
  const onPageChange = (e) => {
    setPageCount(e);
    const params = new URLSearchParams(location.search);
    params.set("page", e)
    navigate(`${location.pathname}?${params.toString()}`, {replace: true});
  };

  const planToAddPlan = () => {
    navigate(RouteConstants.ADD_PLAN);
  };

  const handleSelect = () => {
    setShowDropdown(false);
  };

  const handleToggle = (isOpen) => {
    setShowDropdown(isOpen);
  };

  const handleSortSelect = () => {
    setShowCountDropdown(false);
  };

  const handleSortToggle = (isOpen) => {
    setShowCountDropdown(isOpen);
  };

  const goToLogin = () => {
    navigate(RouteConstants.LOGIN);
    removeCookie("x-access-token");
  };

  const providerValue = {
    getPlanList,
    planList,
    spinnerStatus,
    onPageChange,
    pageCount,
    totalPage,
    handleRoleChange,
    rolesList,
    onClickSortButton,
    sorting,
    setStatus,
    handleSortSelect,
    handleSortToggle,
    selectedStatusId,
    setSelectedStatusId,
    planToAddPlan,
    showCountDropdown,
    status,
    showDropdown,
    handleSelect,
    handleToggle,
    setRoleSelectData,
    roleSelectData,
    roleListShown,
    roleList,
    roleCategotyValidate,
    successAlertShow,
    successAlertMessage,
    statusValue,
    bulkRoleAssignApi,
    setSuccessAlertShow,
    selectedUsers,
    setSelectedUsers,
    setCheckBoxDisable,
    checkBoxDisable,
    setRole,
    status,
    onClickFilterButton,
    selectedSortId,
    setSelectedSortId,
    setSorting,
    permissionAccess,

    errorPopup,
    setErrorPopup,
    errorPopupMessage,
    buttonText,
    goToLogin,
  };

  return (
    <SubsrciptionPlanContext.Provider value={providerValue}>
      {children}
    </SubsrciptionPlanContext.Provider>
  );
};
